
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllPosts } from "@/lib/contentQueries";
import { FaNewspaper } from "react-icons/fa";
import PageShell from "../../components/layout/PageShell";
import PageHeader from "../../components/layout/PageHeader";
import Posts from "../../components/blog/BlogPosts";
import { client } from "../../../tina/__generated__/client";
import StaticRedirect from "@/components/navigation/StaticRedirect";
export default function News(props: any) {
    if (props.redirectTo) {
        return <StaticRedirect destination={props.redirectTo}/>;
    }
    return (<PageShell>
      <PageHeader title="Chess News" description="See what's happening at Chess Hotel and in our chess community." icon={FaNewspaper}/>
      <Posts data={props.posts} mode="news"/>
    </PageShell>);
}
const getStaticProps = async ({ locale }) => {
    if (locale && locale !== "en") {
        return {
            props: { redirectTo: "/news" },
        };
    }
    const postsResponse = await getAllPosts({
        filter: { locale: { eq: "en" } },
    });
    const posts = postsResponse.data.postConnection.edges.filter((edge) => {
        const post = edge?.node;
        const categorySlug = post?.category?.slug;
        const folderCategory = post?._sys?.breadcrumbs?.[0];
        return categorySlug === "news" || folderCategory === "news";
    });
    return {
        props: {
            posts,
        },
    };
};

    async function __Next_Translate__getStaticProps__1a0fc0d5583__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/news/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5583__ as getStaticProps }
  